










































































import { Vue, Component, Prop } from "vue-property-decorator";
import { User as IUser } from "@/api/models/user";
import { Student as IStudent } from "@/api-v2/course/models/student";
import { ContractLearningResource as IContractLearningResource } from "@/api/models/contract-learning-resource";
import api from "@/getinfo-api";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import students, { StudentsListParams } from "@/getinfo-api/students";

@Component({ components: { CustomTableCol, CustomTableItem, CustomTable } })
export default class ContractFormLearningResourceTableItem extends Vue {
  @Prop() resource!: IContractLearningResource;
  @Prop() index!: number;
  @Prop() disableEdit!: boolean;
  showUsersInTable: boolean = false;
  users: Array<IUser> = [];
  students: Array<IStudent> = [];

  getResourceType(resource: IContractLearningResource) {
    if (resource.type === "course") {
      return this.$tc(this.$translate.Course);
    } else if (resource.type === "course2") {
      return this.$tc(this.$translate.Course);
    } else if (resource.type === "webinar") {
      return this.$tc(this.$translate.Webinar);
    } else if (resource.type === "video") {
      return `${this.$tc(this.$translate.Video)}`;
    } else {
      return undefined;
    }
  }

  get createdFrom() {
    return this.resource.creationMethod === 0
      ? `${this.$tc(this.$translate.LearningMaterial)}`
      : this.$tc(this.$translate.LearningRequest);
  }

  get studentUsersSet(): Array<IStudent | IUser> {
    let filteredUsers = this.users.filter(el => {
      return !this.students.some(student => student.userId === el.id);
    });

    return [...this.students, ...filteredUsers];
  }

  goToResourcePage(resource: IContractLearningResource) {
    let routeData: any;
    if (resource.type === "course") {
      routeData = this.$router.resolve({
        name: "courseView",
        params: {
          courseId: resource.id
        }
      });
      this.$router.push({});
    } else if (resource.type === "video") {
      routeData = this.$router.resolve({
        name: "recordView",
        params: {
          id: resource.id
        }
      });
    } else if (resource.type === "course2") {
      routeData = this.$router.resolve({
        name: "course",
        params: {
          id: resource.id
        }
      });
    }
    window.open(routeData.href, "_blank");
  }

  formedUserFullName(user: any) {
    return user?.fullName ??
      [user.firstName, user.lastName, user.middleName].some(el => !!el)
      ? `${user?.lastName} ${user?.firstName} ${user?.middleName ?? ""}`
      : this.$t(this.$translate.NoData);
  }

  linkToStudent(user: any) {
    const userProfile = {
      name: "userProfileView",
      params: { id: user.id }
    };

    const studentProfile = {
      name: "student",
      params: { id: user.id }
    };

    return user?.metadata ? studentProfile : userProfile;
  }

  getUsers() {
    if (this.users.length !== this.resource.userIds.length) {
      this.resource.userIds.forEach(el => {
        api.UsersApi.get(el).then((res: { data: IUser }) => {
          this.users.push(res.data);
        });
      });
    }
  }

  async getStudents() {
    if (this.users.length !== this.resource.userIds.length) {
      try {
        let params: StudentsListParams = {
          ids: this.resource?.userIds,
          limit: 999
        };
        const { data } = await students(params);
        this.students = data.items;
      } catch (e) {
        throw new Error(e);
      }
    }
  }

  showUsers() {
    this.getUsers();
    this.getStudents();
    this.showUsersInTable = !this.showUsersInTable;
  }
}
